import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-pending-validation-popup',
  templateUrl: './pending-validation-popup.component.html',
  styleUrls: ['./pending-validation-popup.component.scss']
})
export class PendingValidationPopupComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PendingValidationPopupComponent>
  ) { }

  ngOnInit(): void {
  }

  close() {
    this.dialogRef.close({ close: true });
  }

}
